import { BookOpen } from "lucide-react";

interface GenieDetailsLinkProps {
  onClick: () => void;
}

/**
 * Header-row entry to the Details view (about, links, resources, summary).
 * Stands in for the floating GenieDetailsTab where that has no room: on
 * desktop while the chat is on screen (the tab would sit on top of the
 * conversation), and on mobile, where it is an icon beside "Show chat".
 * Styled as a sibling of that button and of GenieSupportLink.
 */
export const GenieDetailsLink = ({ onClick }: GenieDetailsLinkProps) => (
  <button
    type="button"
    onClick={onClick}
    aria-label="Open links & resources — about, links, resources & summary"
    title="Links & resources"
    className="inline-flex min-h-[44px] min-w-[44px] shrink-0 items-center justify-center gap-1.5 rounded-xl px-3 text-sm font-medium text-gray-600 transition-colors hover:bg-white hover:text-gray-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-genie-primary"
  >
    <BookOpen className="h-[18px] w-[18px] sm:h-4 sm:w-4" aria-hidden="true" />
    <span className="hidden sm:inline">Links & resources</span>
  </button>
);
